import { analytics } from '../firebase';
import { logEvent } from 'firebase/analytics';

// Minimal, privacy-respecting analytics: page views and outbound clicks only.
export const trackPageView = (pagePath: string) => {
  try {
    if (analytics) {
      logEvent(analytics, 'page_view', {
        page_location: window.location.href,
        page_path: pagePath,
      });
    }
  } catch {
    /* analytics is optional */
  }
};

export const trackOutbound = (url: string, label?: string) => {
  try {
    if (analytics) {
      logEvent(analytics, 'select_content', {
        content_type: 'outbound_link',
        content_id: label ?? url,
      });
    }
  } catch {
    /* analytics is optional */
  }
};
